
import { useScene } from 'src/hooks/useScene';
import { RectangleLabel } from './RectangleLabel';

interface Props {
  rectangles: ReturnType<typeof useScene>['rectangles'];
}

export const RectangleLabels = ({ rectangles }: Props) => {
  // Filter rectangles that have descriptions
  const rectanglesWithDescriptions = rectangles.filter(
    (rect) => rect.description && rect.description.trim() !== ''
  );

  if (rectanglesWithDescriptions.length === 0) {
    return null;
  }

  return (
    <>
      {rectanglesWithDescriptions.map((rectangle) => (
        <RectangleLabel key={rectangle.id} rectangle={rectangle} />
      ))}
    </>
  );
};